/**
 * Returns an array sorted alphabetically using the locale's collation rules.
 * Used for majors / minors / clubs at render time so each locale displays in its own A→Z.
 */
export function sortLocalized(items: readonly string[], locale: string): string[] {
  const collator = new Intl.Collator(locale, { sensitivity: 'base' });
  return [...items].sort((a, b) => collator.compare(a, b));
}
